import { cn } from "@monbits/ui";
import {
	ArrowDownLeft,
	ArrowLeftRight,
	ArrowUpRight,
	type LucideIcon,
	Undo2,
} from "lucide-react";
import type { ReactNode } from "react";

type TransactionType =
	| "incoming"
	| "internal"
	| "withdrawal"
	| "fund_return"
	| "default";

interface TypeBadgeProps {
	children: ReactNode;
	type?: TransactionType;
	className?: string;
	icon?: LucideIcon;
}

const typeConfig: Record<TransactionType, { style: string; icon: LucideIcon }> =
	{
		incoming: {
			style:
				"border-blue-500/30 bg-blue-50/50 text-blue-700 dark:border-blue-500/40 dark:bg-blue-950/30 dark:text-blue-400",
			icon: ArrowDownLeft,
		},
		internal: {
			style:
				"border-purple-500/30 bg-purple-50/50 text-purple-700 dark:border-purple-500/40 dark:bg-purple-950/30 dark:text-purple-400",
			icon: ArrowLeftRight,
		},
		withdrawal: {
			style:
				"border-orange-500/30 bg-orange-50/50 text-orange-700 dark:border-orange-500/40 dark:bg-orange-950/30 dark:text-orange-400",
			icon: ArrowUpRight,
		},
		fund_return: {
			style:
				"border-cyan-500/30 bg-cyan-50/50 text-cyan-700 dark:border-cyan-500/40 dark:bg-cyan-950/30 dark:text-cyan-400",
			icon: Undo2,
		},
		default: {
			style:
				"border-gray-300 bg-gray-50/50 text-gray-700 dark:border-gray-600 dark:bg-gray-800/30 dark:text-gray-300",
			icon: ArrowLeftRight,
		},
	};

export function TypeBadge({
	children,
	type = "default",
	className,
	icon,
}: TypeBadgeProps) {
	const config = typeConfig[type];
	const Icon = icon ?? config.icon;

	return (
		<span
			className={cn(
				"inline-flex items-center gap-1 rounded border px-2.5 py-0.5 text-xs font-medium transition-colors",
				config.style,
				className,
			)}
		>
			<Icon className="h-3.5 w-3.5" />
			{children}
		</span>
	);
}
